// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"success_iconContainer__53Y5F","msgContainer":"success_msgContainer__3_x-F","btnContainer":"success_btnContainer__2HFKp"};